import React from "react";

function Plan({ data }) {
  return (
    <div className="plan section">
      <h2 className="otherhead">Plan</h2>
      <div className="panel">
        {data ? (
          <pre>{data}</pre>
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );
}

export default Plan;
